import { Link } from 'react-router-dom';
import { LandingLayout } from './LandingLayout';

export function PrivacyPage() {
  return (
    <LandingLayout>
      <div className="landing-brand-logo" style={{ marginBottom: 16 }}>
        <Link to="/">
          <img
            src="/help-from-sky-logo.png"
            alt="Help from Sky"
            className="landing-logo-img"
          />
        </Link>
      </div>

      <div className="landing-card" style={{ maxWidth: 720, margin: '0 auto' }}>
        <h1 style={{ fontSize: 32, marginBottom: 24 }}>Privacy Policy</h1>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <section>
            <h3>Our commitment</h3>
            <p>
              Help from Sky is built with privacy at its core. We believe your data belongs to you—not
              us, not advertisers, not third parties.
            </p>
          </section>

          <section>
            <h3>What we collect</h3>
            <p>
              <strong>Beta signup:</strong> When you join our waitlist, we store only the email address
              you provide. We use it solely to send you beta access information.
            </p>
            <p style={{ marginTop: 8 }}>
              <strong>App usage:</strong> Help from Sky stores your business data (clients, appointments,
              services) on your device. We do not access, collect, or sell this data.
            </p>
          </section>

          <section>
            <h3>Data sharing</h3>
            <p>
              We do not sell, rent, or share your personal information with third parties for marketing
              purposes. Period.
            </p>
          </section>

          <section>
            <h3>Optional sync</h3>
            <p>
              If you choose to enable cloud sync in the future, your data will be encrypted and stored
              securely. Sync is always opt-in—never automatic.
            </p>
          </section>

          <section>
            <h3>Cookies &amp; analytics</h3>
            <p>
              This website uses Google Analytics to understand how visitors find and use our pages,
              for example which link or QR code brought them here. Google Analytics sets cookies and
              collects standard usage data such as pages viewed, approximate location and device type.
              It never sees your client or appointment data, which stays on your device. You can opt
              out with the{' '}
              <a href="https://tools.google.com/dlpage/gaoptout">Google Analytics opt-out browser add-on</a>.
            </p>
          </section>

          <section>
            <h3>Contact</h3>
            <p>
              Questions about your data? Email us at{' '}
              <a href="mailto:hello@helpfromsky.com" style={{ color: '#5DB7DE' }}>
                hello@helpfromsky.com
              </a>.
            </p>
          </section>

          <section>
            <p style={{ fontSize: 14 }}>
              Last updated: February 2026
            </p>
          </section>
        </div>
      </div>
    </LandingLayout>
  );
}
